import { render } from "./MenuBar.vue?vue&type=template&id=68588165&scoped=true&ts=true"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"

import "./MenuBar.vue?vue&type=style&index=0&id=68588165&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68588165"]])

export default __exports__